<script lang="ts">
  import { slide } from "svelte/transition";

  import type { Filter, FilterTypesType } from "@shared/types/Filters";

  export let updateFilter: any;
  export let filter: FilterTypesType;
  export let filters: Filter[];
  export let filterExpanded: boolean = false;
  export let hidden: boolean = false;

  let checkedItems = [];
  // Remove invalid filter values
  const removeInvalidFilters = (filters: any) => {
    return filters.filter((f: any) => {
      if (filter.validate !== undefined) {
        return filter.validate(f);
      } else {
        return true;
      }
    });
  };

  $: filters = removeInvalidFilters(filters);
  $: checkedItems = filters.filter(p => p.checked == true);

  let filtersSelected = checkedItems.length > 0;
  let showFilters: any;
  $: filtersSelected = checkedItems.length > 0;
  $: showFilters = filterExpanded || (filterExpanded === null && (filtersSelected || showFilters));

  const filterValue = item => {
    if (filter["id"] == "distributors") {
      return item["name"];
    } else if (filter["id"] == "containers") {
      return item;
    } else {
      return item["id"];
    }
  };
  let filterGroup = filter.value;

  const toggleFilters = () => (filterExpanded = !filterExpanded);

</script>

<style>
  .priority-hide {
    display: none !important;
  }

  .item-count-margin {
    margin-left: auto;
  }

</style>

<dt
  on:click={toggleFilters}
  class={showFilters ? "fizz-is-open" : ""}
  class:priority-hide={hidden}
  id={filter.id + "-filter"}
>
  {filter.name}
</dt>
{#if showFilters}
  <dd
    class="fizz-text-medium fizz-text-subdued"
    class:priority-hide={hidden}
    transition:slide={{ delay: 0, duration: 200, easing: c => c }}
  >
    {#if filters && filters.length > 0}
      <ul class="fizz-flow-4">
        {#each filters as item}
          <li item-id={item.id} id={filter.id + "-" + (item.name || item.id || item)}>
            <label class="fizz-flex-row-8">
              <input
                type="radio"
                class="fizz-radio-button"
                name={filter.id}
                value={filterValue(item)}
                data-testid={`${filter.id}-option`}
                bind:group={filterGroup}
                on:change={() => updateFilter(filter, item)}
              />
              <span>{@html item.highlight || item.name || item.id || item}</span>
              {#if item.count}
                <span class="fizz-text-subdued item-count-margin">({item.count})</span>
              {/if}
            </label>
          </li>
        {/each}
      </ul>
    {:else}
      <span>Nothing matches your search</span>
    {/if}
  </dd>
{/if}
